// @flow
import React from 'react'

import type OptionProps from '../../SelectEnumRefIndex/ReactSelect/Option'

import ReactSelectOption from '../../SelectEnumRefIndex/ReactSelect/Option'

export default class Option extends ReactSelectOption<OptionProps> {
  hasPreferredManufacturerIcon = (): boolean => {
    return this.isPreferredOption() && this.props.option.preferred.icon
  }

  render () {
    return (
      <div
        className={this.props.className}
        onMouseDown={this.handleMouseDown}
        onMouseEnter={this.handleMouseEnter}
        onMouseMove={this.handleMouseMove}
        title={this.props.option.title}
        style={this.getCssStyle()}
      >
        {
          this.hasPreferredManufacturerIcon() &&
          <img src={this.props.option.preferred.icon} alt={this.props.option.title} className="mr-2" width={28} height={28} />
        }
        {
          this.isPreferredOption()
            ? <strong>{this.props.children}</strong>
            : <span>{this.props.children}</span>
        }
      </div>
    )
  }
}
